import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import NotificationService from '../../Services/NotificationService';
import MessageItem from '../../Domain/MessageItem';

export default class NewMessagePanelDescription {
  static titleForCreate = 'New Message';
  static titleForEdit = 'New Message';
  static itemType = MessageItem;
  static messageOnSuccess = 'Message sent.';
  static serviceFunction = (edited) => NotificationService.SendMessage(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Message',
      fields: [
        {
          fieldName: 'ToUserId',
          label: 'To *',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Subject',
          label: 'Subject *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Message',
          label: 'Message *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
